import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CookieService } from "ngx-cookie-service";
import { MsalService } from "@azure/msal-angular";
import { Router } from "@angular/router";
import { environment } from "../../environments/environment.onprem";


@Component({
  selector: "app-logout-dialog",
  standalone: true,
  imports: [],
  templateUrl: "./logout-dialog.component.html",
  styleUrl: "./logout-dialog.component.css",
})
export class LogoutDialogComponent {
  private redirectionUrl = environment.envVar.redirectionUrl;

  constructor(
    private dialog: MatDialog,
    private authService: MsalService,
    private router: Router
  ) {}

  onCancelClick() {
    this.dialog.closeAll();
  }

  logout() {
    sessionStorage.removeItem("isSeenWelcome");
    sessionStorage.removeItem("accessToken");
    sessionStorage.clear();
    // window.location.reload();
    // window.location.replace("/");
    window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${this.redirectionUrl}`
    this.dialog.closeAll();
    sessionStorage.removeItem("accessToken");
  }
}
